import { DatePicker, Form } from "antd";

export default function RenderDatePicker(props) {
	const {
		namePath = [],
		required = false,
		datePickerForm = "MM/DD/YYYY",
	} = props;

	let newNamePath = Array.isArray(namePath) ? namePath.join("_") : namePath;

	return (
		<Form.Item
			name={newNamePath}
			rules={[
				{
					required: required ? true : false,
					message: "This field is required!",
				},
			]}
		>
			<DatePicker style={{ width: "100%" }} format={datePickerForm} />
		</Form.Item>
	);
}
